import { appConfig } from '@configs/index';
import { Backdrop, Box, CircularProgress, Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Image as KonvaImgage, Layer, Stage } from 'react-konva';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { useScreen } from 'usehooks-ts';

type Props = {
    blob?: string;
    onClose?(): void;
};

const imageCache = new Map<string, { image: HTMLImageElement; width: number; height: number }>();

export const invalidateImageCache = (blob?: string, src = appConfig.gateway.blobURL) => {
    if (blob) {
        imageCache.delete(src + blob);
    } else {
        imageCache.clear();
    }
};

export const useImageDimensions = (blob = '', src = appConfig.gateway.blobURL) => {
    const cacheKey = src + blob;
    const cached = blob ? imageCache.get(cacheKey) : undefined;

    const [loading, setLoading] = useState(cached ? false : true);
    const [isError, setIsError] = useState(false);
    const [image, setImage] = useState<HTMLImageElement | undefined>(cached?.image);

    useEffect(() => {
        let cancelled = false;

        if (!blob) {
            setLoading(false);
            setIsError(false);
            setImage(undefined);
            return;
        }

        const existing = imageCache.get(cacheKey);
        if (existing) {
            setImage(existing.image);
            setLoading(false);
            setIsError(false);
            return;
        }

        setLoading(true);
        setIsError(false);
        setImage(undefined);

        const img = new Image();
        img.src = cacheKey;

        img.onload = () => {
            imageCache.set(cacheKey, { image: img, width: img.width, height: img.height });
            if (cancelled) return;
            setImage(img);
            setLoading(false);
        };

        img.onerror = () => {
            if (cancelled) return;
            setLoading(false);
            setIsError(true);
        };

        return () => {
            cancelled = true;
        };
    }, [blob, src, cacheKey]);

    return {
        image,
        loading,
        isError,
    };
};

const PreviewImage = (props: Props) => {
    const { image } = useImageDimensions(props.blob);
    const screen = useScreen();

    if (!image?.width || !image?.height || !screen)
        return (
            <Backdrop open sx={{ zIndex: (theme) => theme.zIndex.appBar + 1 }}>
                <CircularProgress />
            </Backdrop>
        );

    const defaultHeight = screen.availHeight * 0.75;
    const scale = image.height < defaultHeight ? 1 : defaultHeight / image.height;
    const displayWidth = image.width * scale;
    const displayHeight = image.height * scale;

    return (
        <Dialog
            open={!!props.blob}
            onClose={props.onClose}
            PaperProps={{
                sx: {
                    minWidth: displayWidth,
                    minHeight: displayHeight,
                },
            }}
        >
            <div>
                {/* <img src={props.image} alt="" style={{ objectFit: 'contain', width: '80vw' }} /> */}
                <Stage width={displayWidth} height={displayHeight}>
                    <Layer>
                        <KonvaImgage image={image} scaleX={scale} scaleY={scale} onClick={(e) => console.log(e)} />
                        {/* {!!prevGeoZones?.length &&
                            prevGeoZones?.map((frame, frameIndex) => {
                                const center = getCenterFrame(frame);
                                return (
                                    <React.Fragment key={`frame-${frameIndex}`}>
                                        <Line points={frame.flatMap((point) => [point.x, point.y])} stroke="blue" />
                                        <Circle x={center.x} y={center.y} radius={15} fill="#fff" />
                                        <Text
                                            x={center.x}
                                            y={center.y}
                                            text={String(`${frameIndex + 1}`)}
                                            fontSize={14}
                                            fill={'black'}
                                            align={'center'}
                                            verticalAlign={'middle'}
                                            offsetX={4}
                                            offsetY={6}
                                        />
                                    </React.Fragment>
                                );
                            })} */}
                    </Layer>
                </Stage>
            </div>
        </Dialog>
    );
};

export default React.memo(PreviewImage);
